import React, { useEffect, useState } from 'react';
import styles from "./VariationTable.module.scss";
import DynamicTable from '../../common/DynamicTable/DynamicTable';
import { FiTrash2 } from "react-icons/fi";
import { Button, Input } from 'reactstrap';
import UploadMedia from '../../common/UploadMedia/UploadMedia';
import { GiPanda } from "react-icons/gi";

const VariationTable = ({ combinations }) => {
    const [tableData, setTableData] = useState([]);
    const [variationImages, setVariationImages] = useState([]);

    useEffect(() => {
        // Prepare table data from combinations
        const initialData = combinations.map((combination, index) => ({
            id: index,
            variations: combination,
            sku: "",
            price: "",
            discountedPrice: "",
            quantity: "",
        }));
        setTableData(initialData);
    }, [combinations]);

    // Handle updates for individual row inputs
    const handleInputChange = (index, field, value) => {
        const updatedData = [...tableData];
        updatedData[index][field] = value;
        setTableData(updatedData);
    };

    // Define columns for DataTable
    const columns = [
        {
            name: "Variations",
            cell: (row) => (
                <div className={styles.variationsDataRow}>
                    {Object.keys(row.variations).map((key) => (
                        <div key={key}>
                            <span>{key}</span>: {row.variations[key]}<br />
                        </div>
                    ))}
                </div>
            ),
            sortable: false,
            wrap: true,
            // width: '150px',
        },
        {
            name: "SKU",
            cell: (row, index) => (
                <>
                    <Input
                        type="text"
                        placeholder="Add SKU"
                        value={row.sku}
                        onChange={(e) =>
                            handleInputChange(index, "sku", e.target.value)
                        }
                    />
                    <div color="link" className={styles.suggestionText}>
                        <GiPanda size={18} className={styles.pandaImg} />
                        Al-generate
                    </div>
                </>
            ),
            minWidth: '300px',
        },
        {
            name: "Price | Discounted Price",
            cell: (row, index) => (
                <div className={styles.pricesRow}>
                    <div className={styles.priceInputGroup}>
                        <Input
                            type="text"
                            placeholder="Price"
                            value={row.price}
                            onChange={(e) =>
                                handleInputChange(index, "price", e.target.value)
                            }
                            className={styles.priceInput}
                        />
                        <Input
                            type="text"
                            placeholder="D.P."
                            value={row.discountedPrice}
                            onChange={(e) =>
                                handleInputChange(index, "discountedPrice", e.target.value)
                            }
                            className={styles.discountedPriceInput}
                        />
                    </div>
                    <div color="link" className={styles.suggestionText}>
                        <GiPanda size={18} className={styles.pandaImg} />
                        $15.00/ $13.00
                    </div>
                </div>
            ),
            minWidth: '340px',
        },
        {
            name: "Quantity",
            cell: (row, index) => (
                <Input
                    type="text"
                    placeholder="Add quantity"
                    value={row.quantity}
                    onChange={(e) =>
                        handleInputChange(index, "quantity", e.target.value)
                    }
                />
            ),
        },
        // {
        //     name: "Images",
        //     cell: (row, index) => (
        //         <UploadMedia
        //             pictures={variationImages}
        //             setPictures={setVariationImages}
        //             // imgs={imgs}
        //             // setImgs={setImgs}
        //             maxMedia={6}
        //             allowImages={true}
        //             allowVideos={true}
        //         />
        //     ),
        //     ignoreRowClick: true,
        //     allowOverflow: true,
        //     // button: true,
        // },
    ];

    // Handle row deletion
    const handleDeleteRow = (index) => {
        const updatedData = tableData.filter((_, i) => i !== index);
        setTableData(updatedData);
    };

    return (
        <div>
            {combinations.length > 0 && (
                <div className={styles.combinationContainer}>
                    <h5 className={styles.combinationTitle}>Variation Combinations</h5>
                    <DynamicTable
                        columns={columns}
                        data={tableData}
                        onRowDelete={handleDeleteRow}
                        customStyles={customStyles}
                        isPagination={true}
                    />
                </div>
            )}
        </div>
    )
};

const customStyles = {
    table: {
        style: {
            border: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
            borderBottom: 'none',
        },
    },
    rows: {
        style: {
            borderBottom: 'none !important',
        },
    },
    headCells: {
        style: {
            borderBottom: 'none',
            paddingLeft: "8px",
            paddingRight: "8px",
            fontSize: '14px',
            fontWeight: '400',
            color: '#1A2425',
            justifyContent: 'center',
        },
    },
    cells: {
        style: {
            borderBottom: 'none',
            paddingLeft: "8px",
            paddingRight: "8px",
            fontSize: '14px',
            fontWeight: '400',
            color: '#1A2425',
            padding: '20px 8px',
        },
    },
};

export default VariationTable;
